<template>
  <div class="modal fade" id="relatedGlossaryTermsModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Glossary
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          v-for="(keyword, index) in keywords.slice().sort($orderByName)"
          :key="keyword.Keywrd_Id"
          class="row pt-2 text-left px-4"
          v-bind:class="{ 'light-background': index % 2 === 1 }"
        >
          <div class="col">
            <p class="mb-1">
              <b>{{ keyword.Name }}</b>
            </p>
            <p style="white-space: pre-wrap;">
              {{ keyword.Definition }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Template",
  props: {
    ApplicabilityFlag: Number
  },
  data() {
    return {
      keywords: []
    };
  },
  async mounted() {
    var view = this;
    try {
      await view
        .$getApplicableKeywords(view.ApplicabilityFlag)
        .then(keywords => {
          view.keywords = keywords;
        });
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
